<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="门票编码" prop="name">
          <el-input v-model="dataForm.couponNo" placeholder="门票编码"></el-input>
      </el-form-item>
          <el-form-item label="门票名称" prop="count">
          <el-input v-model="dataForm.name" placeholder="门票名称"></el-input>
      </el-form-item>
        <el-form-item label="开始日期" prop="startTime">
          <el-date-picker
                v-model="dataForm.effectiveDateString"
                type="date"
                :clearable="true"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                placeholder="截止时间">
        </el-date-picker>
        至
        <el-date-picker
                v-model="dataForm.expireDateString"
                type="date"
                :clearable="true"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                placeholder="截止时间">
        </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
            <el-select v-model="dataForm.status"
                       placeholder="：0->未激活；1->已激活；2->已使用;3-删除">
                <el-option v-for="item in couponStatus"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="备注" prop="note">
          <el-input v-model="dataForm.useRuleDesc" placeholder="备注"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
        couponStatus:[
            {
                value: 1,
                label: '未激活'
            }, {
                value: 2,
                label: '已激活'
            }, {
                value: 3,
                label: '已使用'
            },
            {
                value: 4,
                label: '已删除'
            }
        ],
      dataForm: {
           id: '',
          couponNo: '',
          name: '',
          expireDateString: '',
          effectiveDateString: '',
          status: '',
          useRuleDesc: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
          couponNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
          expireDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
          effectiveDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
          status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sms/ticketcoupon/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sms/ticketcoupon/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
